import { UiConfig } from 'common/types/config';
import { set } from 'radashi';

declare global {
    interface Window {
        env: string;
    }
}

const paramPrefix = 'config_override_';
const params = new URLSearchParams(window.location.search);
let config = {};

if (window.env !== '{{INJECT_ENV}}') {
    Object.assign(config, JSON.parse(window.env));
}

for (const [key, value] of params) {
    if (key.startsWith(paramPrefix)) {
        config = set(config, key.slice(paramPrefix.length), value);
    }
}

window.config = UiConfig.parse(config);
